import "./style/index.scss";
import * as Icon from "@ant-design/icons";
import { Col, Flex, Form, Modal, Row } from "antd";
import Search from "antd/lib/input/Search";
import { ColumnsType } from "antd/lib/table";
import { useEffect } from "react";
import { AtivoModel } from "../../../../models/ativoModel";
import { TaxaImpostoModel } from "../../../../models/taxaImposto/taxaImpostoModel";
import { setTitle } from "../../../../redux/slices/configuracoes/configuracoesSlice";
import { setEntityTaxaImposto, setBuscaTaxaImposto, setPageTaxaImposto, setModalDeletarTaxaImposto } from "../../../../redux/slices/taxaImposto/taxaImpostoSlice";
import { buscarContaBanco } from "../../../../services/contaBancoService";
import { atualizarTaxaImpostoAtivo, buscarTaxaImposto, deletarTaxaImposto } from "../../../../services/taxaImpostoService";
import { buscarTipoTaxaImposto } from "../../../../services/tipoTaxaImpostoService";
import { currencyBRL } from "../../../../util/dinheiroBRAuxiliar";
import { useAppDispatch, useAppSelector } from "../../../../util/hooks";
import { Vm_ContaBancoModel } from "../../../../models/contaBanco/vm_contaBancoModel";
import { BuscarTaxaImpostoModel } from "../../../../models/taxaImposto/buscaTaxaImpostoModel";
import { ItemMenuAcoes } from "../../../../models/sistema/itemMenuAcoes";
import AcoesComponent from "../../../../components/table/acoesComponent";
import MensagemModal from "../../../../components/modal/mensagem";
import TableComponent from "../../../../components/table/tableComponent";
import { ButtonComponent } from "../../../../components/button/cadastrar";
import { SwitchComponent } from "../../../../components/button/switch";

const GeralPage = () => {
  //estados globais
  const taxaImpostoState = useAppSelector((state) => state.taxaImposto);
  const contaBancoState = useAppSelector((state) => state.contaBanco);
  const tipoTaxaImpostoState = useAppSelector((state) => state.tipoTaxaImposto);

  //hooks
  const dispatch = useAppDispatch();

  //estados locais
  useEffect(() => {
    dispatch(setTitle("IMPOSTOS E TAXAS"));
    dispatch(buscarTaxaImposto(taxaImpostoState.busca));
    dispatch(buscarContaBanco(contaBancoState.busca));
    dispatch(buscarTipoTaxaImposto(tipoTaxaImpostoState.busca));
  }, []);

  const goCadastrar = () => {
    dispatch(setEntityTaxaImposto({}));
    dispatch(setPageTaxaImposto("cadastrar"));
  };

  const goEditar = (value: TaxaImpostoModel) => {
    dispatch(setEntityTaxaImposto(value));
    dispatch(setPageTaxaImposto("cadastrar"));
  };

  const goDeletar = (value: TaxaImpostoModel) => {
    dispatch(setEntityTaxaImposto(value));
    dispatch(setModalDeletarTaxaImposto(true));
  };

  const closeModalDeletar = () => {
    dispatch(setModalDeletarTaxaImposto(false));
  };

  const onChangeAtivo = (value: TaxaImpostoModel) => {
    let args: AtivoModel = {
      id: value.id,
      ativo: !value.ativo,
    };
    dispatch(atualizarTaxaImpostoAtivo({ value: args, busca: taxaImpostoState.busca }));
  };

  const onSearch = (value: string) => {
    let busca: BuscarTaxaImpostoModel = { ...taxaImpostoState.busca, pesquisar: value };

    dispatch(setBuscaTaxaImposto(busca));
    dispatch(buscarTaxaImposto(busca));
  };

  const items: ItemMenuAcoes[] = [
    {
      label: "Editar",
      key: "1",
      icon: <Icon.EditOutlined />,
      function: (item: any) => goEditar(item),
    },
    {
      label: "Remover",
      key: "2",
      icon: <Icon.DeleteOutlined />,
      function: (item: any) => goDeletar(item),
    },
  ];

  const columns: ColumnsType<TaxaImpostoModel> = [
    {
      title: "IMPOSTO / TAXA",
      dataIndex: "denominacao",
      align: "center",
      width: 120,
      sorter: (a, b) => a.denominacao.localeCompare(b.denominacao),
      sortDirections: ["ascend", "descend", "ascend"],
    },
    {
      title: "PERCENTUAL/VALOR",
      align: "center",
      width: 120,
      sorter: (a, b) => {
        const valueA = a.valorFixoImposto ?? a.percentual ?? 0;
        const valueB = b.valorFixoImposto ?? b.percentual ?? 0;
        return valueA - valueB;
      },
      sortDirections: ["ascend", "descend", "ascend"],
      render: (_, record) => {
        const { percentual, valorFixoImposto } = record;
        if (valorFixoImposto === null) {
          return percentual ? `${percentual.toFixed(2)}%` : "";
        } else {
          return currencyBRL(valorFixoImposto);
        }
      },
    },
    {
      title: "CONTA BANCÁRIA",
      dataIndex: "conta_IdContaBanco",
      align: "center",
      width: 120,
      sorter: (a, b) => (a.conta_IdContaBanco ?? 0) - (b.conta_IdContaBanco ?? 0),
      sortDirections: ["ascend", "descend", "ascend"],
      render: (_, record) => {
        return <>{contaBancoState.list.find((a: Vm_ContaBancoModel) => a.id === record.conta_IdContaBanco)?.denominacaoPersonalizada}</>;
      },
    },
    {
      title: "GERA CONTA A PAGAR",
      dataIndex: "geraContaFinanceira",
      align: "center",
      width: 120,
      render: (_, record) => <SwitchComponent checked={record.geraContaFinanceira} disabled />,
    },
    {
      title: "TIPO",
      dataIndex: "idTipoTaxaImposto",
      align: "center",
      width: 120,
      sorter: (a, b) => a.denominacao.localeCompare(b.denominacao),
      sortDirections: ["ascend", "descend", "ascend"],
      render: (_, record) => {
        return <>{tipoTaxaImpostoState.list.find((a: any) => a.id === record.idTipoTaxaImposto)?.denominacao}</>;
      },
    },
    {
      title: "DEBITA DA FONTE",
      dataIndex: "debitaPrincipal",
      align: "center",
      width: 120,
      render: (_, record) => <SwitchComponent checked={record.debitaPrincipal} disabled />,
    },
    {
      title: "ATIVO",
      dataIndex: "ativo",
      align: "center",
      width: 100,
      filters: [
        {
          text: "Ativo",
          value: "true" as any,
        },
        {
          text: "Inativo",
          value: "false" as any,
        },
      ],
      onFilter: (value: any, record: any) => record.ativo.toString().includes(value),
      defaultFilteredValue: ["true" as any],
      render: (_, record) => <SwitchComponent onChange={() => onChangeAtivo(record)} checked={record.ativo} />,
    },
    {
      title: "AÇÕES",
      dataIndex: "acoes",
      align: "center",
      width: 75,
      render: (_, record) => <AcoesComponent record={record} items={items} />,
    },
  ];

  return (
    <Flex vertical>
      <Form layout="vertical">
        <Row gutter={12} align="bottom">
          <Col span={20}>
            <Flex gap={12}>
              <Form.Item label="Pesquisar" name="pesquisar">
                <Search allowClear placeholder="Imposto/Taxa" onSearch={onSearch} className="searchInput" enterButton style={{ width: 300 }} />
              </Form.Item>
            </Flex>
          </Col>
          <Col span={4}>
            <Flex justify="end">
              <ButtonComponent onClick={goCadastrar} />
            </Flex>
          </Col>
        </Row>
      </Form>
      <TableComponent data={taxaImpostoState.list} columns={columns} loading={taxaImpostoState.loading} />
      <Modal title={"REMOVER IMPOSTO/TAXA"} centered width={350} open={taxaImpostoState.modalDeletar} onCancel={closeModalDeletar} footer={null} destroyOnHidden>
        <MensagemModal
          text="Deseja remover o imposto/taxa?"
          action={deletarTaxaImposto({ value: taxaImpostoState.entity.id, busca: taxaImpostoState.busca })}
          close={setModalDeletarTaxaImposto(false)}
        />
      </Modal>
    </Flex>
  );
};

export default GeralPage;
